<div class="min-h-screen bg-gradient-to-br from-slate-800 to-slate-950 flex items-center justify-center p-4">
  <div class="bg-white rounded-lg shadow-2xl max-w-md w-full p-6 overflow-hidden relative">
    <!-- <div class="flex justify-center mb-6">
      <div class="relative">
        <div class="w-24 h-24 rounded-full bg-slate-100 flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-slate-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div class="absolute inset-0 rounded-full bg-slate-400 opacity-25 animate-ping"></div>
      </div>
    </div> -->

    <div class="mb-4 text-center">
      <p class="text-5xl font-bold text-slate-800 mb-2">404</p>
      <h1 class="text-2xl font-bold text-slate-700 mb-1">Page not found</h1>
      <p class="text-gray-600">This page does not exist or the link is incorrect.</p>
      @if (attemptedUrl) {
        <p class="mt-2 text-xs text-gray-400 break-all">{{ attemptedUrl }}</p>
      }
    </div>

    <div class="flex flex-col sm:flex-row gap-3">
      <button
        type="button"
        (click)="goBack()"
        class="bg-slate-700 text-white py-2 px-4 rounded-lg hover:bg-slate-800 transition duration-200 flex-1 flex items-center justify-center cursor-pointer"
      >
        Go back
      </button> 
    </div>

    <!-- <div class="absolute -top-10 -right-10 w-24 h-24 bg-slate-400 rounded-full opacity-20"></div>
    <div class="absolute -bottom-10 -left-10 w-24 h-24 bg-slate-400 rounded-full opacity-20"></div> -->
  </div>
</div>
